module.exports = __webpack_public_path__ + "img/square-plus-sharp-light.4db6f09e.svg";